<template>
  <div class="app-search dropdown d-none d-lg-block">
    <form @submit.prevent="globalSearch">
      <div class="app-search-content input-group">
        <base-input
          v-model="keyword"
          type="text"
          :placeholder="$t('components.global_search.search')"
          id="top-search"
          item-class="custom-input-group-append border border-end-0 rounded-start"
        />
        <span class="mdi mdi-magnify search-icon"></span>
        <base-button item-class="btn-primary border-0" :disabled="isDisabled === true">
          {{
            loading === true ? $t('components.global_search.searching') + '...' : $t('components.global_search.search')
          }}
        </base-button>
      </div>
    </form>
    <dropdown item-class="dropdown-lg" :show="showSearch" :right="false">
      <!-- item-->
      <div class="dropdown-item noti-title">
        <p class="mb-0">
          {{ $t('components.global_search.total_result') }}:
          <strong class="text-danger">{{ results.total }}</strong>
        </p>
      </div>
      <div class="slimScrollDiv">
        <div class="slimscroll">
          <template v-for="(result, key) in results.hits" :key="key">
            <div class="dropdown-header noti-title p-0">
              <p class="text-overflow text-uppercase fw-bold mb-0 bg-primary-lighten px-2 py-1">
                {{ indexes[key].title }} ({{ result.length }})
              </p>
              <div class="notification-list">
                <router-link
                  :to="{
                    name: indexes[item._index].route,
                    params: { id: item._source.id }
                  }"
                  class="dropdown-item notify-item text-decoration-none px-0 py-1"
                  v-for="item in result"
                  :key="item._id"
                >
                  <div class="media px-2">
                    <div class="media-body">
                      <p class="m-0 font-14">
                        {{ item._source.id }} -
                        {{ item._source[indexes[item._index].field] }}
                        <template v-if="item._source.forward_price">
                          -
                          <strong>{{ money.ofMinor(item._source.forward_price).getFormattedAmount() }}</strong>
                        </template>
                      </p>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </template>
        </div>
      </div>
    </dropdown>
  </div>
</template>
<script setup>
import { ref, reactive, computed, onMounted, onBeforeUnmount } from 'vue'

import { useStore } from 'vuex'

import i18n from '@/i18n/i18n'

import money from '@/utilities/money'

const { t } = i18n.global

// #region - importing components
import BaseButton from '@/components/BaseButton'
import BaseInput from '@/components/BaseInput'
import Dropdown from '@/components/Dropdown'
// endregion

// #region - Vuex store
const store = useStore()
// endregion

// #region - References
const keyword = ref('')
const showSearchResults = ref(false)
const disabled = ref(false)
const loading = ref(false)
const indexes = reactive({
  farmers_index: {
    title: t('components.global_search.farmer_index_title'),
    route: 'admin.farmers.show',
    field: 'fullname'
  },
  orders_index: {
    title: t('components.global_search.order_index_title'),
    route: 'admin.orders.show',
    field: 'farmer'
  },
  applications_index: {
    title: t('components.global_search.application_index_title'),
    route: 'admin.applications.show',
    field: 'farmer'
  },
  retailers_index: {
    title: t('components.global_search.retailer_index_title'),
    route: 'admin.retailers.show',
    field: 'name'
  }
})
// endregion

// #region - computed properties
const results = computed(() => store.state.adminSearch.results)

const showSearch = computed(() => (showSearchResults.value ? 'show' : ''))

const isDisabled = computed(() => {
  if (keyword.value) {
    return disabled.value
  }
  return true
})
// endregion

// #region - Method definitions
const globalSearch = async () => {
  if (keyword.value) {
    loading.value = true
    disabled.value = true
    try {
      await store.dispatch('adminSearch/search', { keyword: keyword.value })
      showSearchResults.value = true
    } catch (error) {
      disabled.value = true
      showSearchResults.value = false
      throw new Error('Search Error:', error)
    } finally {
      loading.value = false
      disabled.value = false
    }
  }
}
const close = e => {
  if (!e.target.closest('.app-search')) {
    showSearchResults.value = false
  }
}
// endregion

onMounted(() => window.addEventListener('click', close))
onBeforeUnmount(() => window.removeEventListener('click', close))
</script>

<style lang="scss" scoped>
.app-search-content {
  flex-wrap: nowrap;
}
</style>
